import React from "react";
import { Box, Typography, useTheme, Button } from "@mui/material";
import { Link } from "react-router-dom";

export const Error403 = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "calc(100vh - 164px)",
        backgroundColor: theme.palette.background.default,
      }}>
      <Typography variant="h1" color="primary" gutterBottom>
        403
      </Typography>
      <Typography variant="h4" color="text.secondary">
        Forbidden
      </Typography>
      <Typography variant="body1" color="text.secondary" mt={2}>
        You don't have permission to access this page.
      </Typography>
    </Box>
  );
};
